import {ElementRef, InjectionToken, Provider} from "@angular/core";

/** Wrapper rundt {@link IntersectionObserver} som lar deg registrer et callback
 * som kalles når angitt html-element blir synlig i viewport */
export class ElementSynlighetObservering {
    private readonly intersectionObserverbar: IntersectionObserver;
    private readonly elementTilCallbackBinding = new WeakMap<Element, NårSynlig>();

    constructor(private opsjoner?: Opsjoner) {
        this.intersectionObserverbar = new IntersectionObserver(innslag =>
            innslag
              .filter(innslag => innslag.isIntersecting)
              .forEach(innslag => this.harBlittSynlig(innslag)),
          this.opsjoner);
    }

    nårElementBlirSynlig(element: Element, nårSynlig: NårSynlig) {
        this.elementTilCallbackBinding.set(element, nårSynlig);
        this.intersectionObserverbar.observe(element);
    }

    avregistrer(element: Element) {
        this.intersectionObserverbar.unobserve(element);
        this.elementTilCallbackBinding.delete(element);
    }

    //private hjelpemetoder

    private harBlittSynlig(innslag: IntersectionObserverEntry) {
        if (!this.elementTilCallbackBinding.has(innslag.target)) return;
        this.elementTilCallbackBinding.get(innslag.target)!(innslag);

        if(this.opsjoner?.avregistrerEtterFørsteSynlig === true) {
            this.intersectionObserverbar.unobserve(innslag.target);
            this.elementTilCallbackBinding.delete(innslag.target);
        }
    }

}

export type Opsjoner = IntersectionObserverInit & {
    /** Sørger for at nårSynlig kun blir kalt første gang elementet blir synlig */
    avregistrerEtterFørsteSynlig?: boolean
};

export type NårSynlig = (intersection: IntersectionObserverEntry) => void;

/** For bruk ifbm tilgjengelig-gjøring for barn av komponent via komponentens `providers` attributt.
 * @arg token injection token ElementSynlighetObservering instansen skal registreres under
 * @arg opsjoner metode som får html-elementet som komponenten vi reg provideren på som argument, gjør det mulig
 * å feks sette {@link IntersectionObserverInit#root} til komponentens html-element
 */
export function elementSynlighetObserveringSomProvider(token: InjectionToken<ElementSynlighetObservering>, opsjoner?: (komponentElement: HTMLElement) => Opsjoner): Provider {
    const fabrikk = (el: ElementRef<HTMLElement>) => new ElementSynlighetObservering(opsjoner?.(el.nativeElement));
    return {provide: token, useFactory: fabrikk, deps: [ElementRef<HTMLElement>]};
}
